module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-3GENNAIO-25-small-b1b728a6727689a1b35479b560393162.png";